module.exports = __webpack_public_path__ + "images/midday_sun-12cd892f2402198a0ca4ce14bcdf0caa.jpg";